import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export interface User {
    id_usuario: number
    nombre_usuario: string
    correo: string | null
    nombre: string
    apellido_paterno: string | null
    apellido_materno: string | null
    telefono_oficina: string | null
    telefono_personal: string | null
    nomina_empleado: number | null
    activo: boolean
    roles: UserRole[]
    permissions: string[]
    menus: MenuItem[]
    empresas: number[]
    sucursales: number[]
}

export interface UserRole {
    id_rol: number
    nombre: string
}

export interface MenuItem {
    id: string
    label: string
    icon?: string | null
    href?: string | null
    id_menu_padre?: string | null
    orden?: number | null
    mostrar_en_produccion: boolean
    required_permissions: string[]
    children: MenuItem[]
}



export interface AuthState {
    user: User | null
    token: string | null
    expiresAt: string | null
    isAuthenticated: boolean

    setAuth: (user: User, token: string, expiresAt: string) => void
    logout: () => void
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set) => ({
            user: null,
            token: null,
            expiresAt: null,
            isAuthenticated: false,

            setAuth: (user, token, expiresAt) => {
                set({ user, token, expiresAt, isAuthenticated: true })
            },

            logout: () => {
                // reset state
                set({ user: null, token: null, expiresAt: null, isAuthenticated: false })
                // remove completely from storage
                useAuthStore.persist.clearStorage()
            },
        }),
        {
            name: 'auth-storage',
            storage: createJSONStorage(() => window.localStorage),
        }
    )
)